import { SAGE_PRODUCT_CODES } from 'constants/App';

export const mapperPermissionsList = (permissionsList) => {
    const permissions = {};
    if (!permissionsList || permissionsList.length === 0) {
        return permissions;
    }

    permissionsList.forEach((permission) => {
        const { rootId, name } = permission;
        const parent = rootId.toString();

        if (parent === '-1') {
            const list = permissions[name] ? permissions[name].list : [];
            permissions[name] = {
                ...permission,
                list,
            };
        } else if (permissions[parent] && permissions[parent].list) {
            permissions[parent].list.push(permission);
        } else {
            const list = permissions[parent] ? permissions[parent].list : [permission];
            permissions[parent] = {
                ...permissions[parent],
                list,
            };
        }
    });

    return permissions;
};

export const showIntegrations = (productCode) => {
    return (
        !!productCode &&
        productCode !== SAGE_PRODUCT_CODES.SAGE && // Skips 'sage_crm' because 'sage_sbca' doesn't have addontask
        Object.values(SAGE_PRODUCT_CODES).includes(productCode)
    );
};
